// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"412cd132","241":"93759e90","813":"1c693257"}[chunkId] + ".css";
};